"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteStatus = exports.BlockchainNetworkId = exports.ProposalStatus = void 0;
var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["WAITING"] = "0";
    ProposalStatus["VOTING"] = "1";
    ProposalStatus["FAIL"] = "2";
    ProposalStatus["PASS"] = "3";
})(ProposalStatus = exports.ProposalStatus || (exports.ProposalStatus = {}));
var BlockchainNetworkId;
(function (BlockchainNetworkId) {
    BlockchainNetworkId[BlockchainNetworkId["mainnet"] = 1] = "mainnet";
    BlockchainNetworkId[BlockchainNetworkId["ropsten"] = 3] = "ropsten";
    BlockchainNetworkId[BlockchainNetworkId["rinkeby"] = 4] = "rinkeby";
    BlockchainNetworkId[BlockchainNetworkId["goerli"] = 5] = "goerli";
    BlockchainNetworkId[BlockchainNetworkId["dev"] = 2018] = "dev";
    BlockchainNetworkId[BlockchainNetworkId["classic"] = 61] = "classic";
    BlockchainNetworkId[BlockchainNetworkId["mordor"] = 63] = "mordor";
    BlockchainNetworkId[BlockchainNetworkId["kotti"] = 6] = "kotti";
    BlockchainNetworkId[BlockchainNetworkId["smartchain"] = 56] = "smartchain";
    BlockchainNetworkId[BlockchainNetworkId["smartchainTestnet"] = 97] = "smartchainTestnet";
})(BlockchainNetworkId = exports.BlockchainNetworkId || (exports.BlockchainNetworkId = {}));
var VoteStatus;
(function (VoteStatus) {
    VoteStatus["NO"] = "0x564f54455f4e4f";
    VoteStatus["YES"] = "0x564f54455f594553"; // web3.utils.fromAscii("VOTE_YES")
})(VoteStatus = exports.VoteStatus || (exports.VoteStatus = {}));
//# sourceMappingURL=types.js.map